import React, { useState } from 'react';
import './Projects.css';

const Projects = () => {
  const [expandedProjects, setExpandedProjects] = useState(new Set([0, 1]));
  const [selectedFilter, setSelectedFilter] = useState('All');

  const projects = [
    {
      title: 'UAE Banking Sector Analytics & Performance Dashboard',
      category: 'Power BI Dashboards',
      tools: ['Power BI', 'DAX', 'Financial Modeling', 'KPI Scorecards'],
      dataset: 'UAE Banking Industry Financial Portfolios',
      description:
        'An interactive Power BI report analyzing UAE banking sector metrics, customer performance, loan portfolios, and financial data insights. Features executive KPI scorecards, risk assessment, and dynamic trend analysis.',
      iframeUrl: 'https://www.youtube.com/embed/MaPZT8RYEUk',
      button: {
        text: 'Watch Video Walkthrough',
        url: 'https://youtu.be/MaPZT8RYEUk',
        icon: 'fab fa-youtube'
      }
    },
    {
      title: 'UAE Emirates Demographics & Economic Growth Analysis',
      category: 'Power BI Dashboards',
      tools: ['Power BI', 'DAX', 'Demographic Analysis', 'Geospatial Mapping'],
      dataset: 'National Census & Socioeconomic Data (7 Emirates)',
      description:
        'A comprehensive Power BI dashboard analyzing United Arab Emirates demographic patterns, regional economic indicators, population distributions, and socioeconomic growth trends across all seven emirates.',
      iframeUrl: 'https://www.youtube.com/embed/t08PBBo2I1Y',
      button: {
        text: 'Watch Video Walkthrough',
        url: 'https://youtu.be/t08PBBo2I1Y',
        icon: 'fab fa-youtube'
      }
    },
    {
      title: 'Retail Market Basket & Consumer Purchasing Behavior',
      category: 'Tableau & Visual Analytics',
      tools: ['Tableau', 'Apriori Algorithm', 'Python', 'Affinity Analysis'],
      dataset: '10,000+ Retail Billing Transactions',
      description:
        'Analyzed 10,000 retail transaction records to identify hidden product pairing patterns. Applied the Apriori Algorithm to formulate item affinities and forecast purchasing patterns, formulating actionable cross-merchandising strategies.',
      button3: {
        text: 'View Case Study',
        url: 'https://public.tableau.com/app/profile/monil.shah6411'
      }
    },
    {
      title: 'Foreign Direct Investment (FDI) Trends & Economic Indicators',
      category: 'Tableau & Visual Analytics',
      tools: ['Tableau Public', 'Correlation Matrices', 'Trend Forecasting'],
      dataset: 'Multinational FDI Inflows by Sector & Region',
      description:
        'Visualized global and national FDI trends across diverse industrial sectors. Performed correlation analysis between foreign capital inflows and regional economic metrics to pinpoint key growth catalysts.',
      button3: {
        text: 'Visit Interactive Tableau Viz',
        url: 'https://public.tableau.com/views/FDA_17269313860500/Top5industrisesof2015-16?:language=en-US&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link'
      }
    },
    {
      title: 'Entertainer Industry Audience Analytics & Trend Forecasting',
      category: 'Tableau & Visual Analytics',
      tools: ['Tableau', 'K-Means Clustering', 'Audience Segmentation'],
      dataset: 'Entertainment Industry Demographics & Breakthroughs',
      description:
        'Analyzed audience engagement and demographic patterns using interactive Tableau dashboards. Segmented consumers using clustering techniques to predict upcoming media release performance.',
      button3: {
        text: 'Visit Interactive Tableau Viz',
        url: 'https://public.tableau.com/app/profile/monil.shah6411/viz/Entertainerdataanalyst/Averageageofbreakthrough'
      }
    },
    {
      title: 'Agricultural Crop Yield & Climatic Pattern Regression Analysis',
      category: 'Tableau & Visual Analytics',
      tools: ['Tableau', 'Multivariate Regression', 'Geographic Heatmaps'],
      dataset: 'Longitudinal Agricultural Production & Rainfall Metrics',
      description:
        'Visualized agricultural production yields against multi-year meteorological variables. Conducted regression analysis to isolate climate sensitivity and recommend region-specific crop strategies.',
      button3: {
        text: 'Visit Interactive Tableau Viz',
        url: 'https://public.tableau.com/views/Cropproductionanalysis_17282080507470/Story1?:language=en-US&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link'
      }
    },
    {
      title: 'Cardiovascular 10-Year Risk Predictive Modeling Engine',
      category: 'Predictive & Statistical Analytics',
      tools: ['Python', 'Scikit-Learn', 'Statistical Risk Scoring', 'React'],
      dataset: 'Framingham Heart Study (2008) & Uppsala Sleep Study (2025)',
      description:
        'A science-backed statistical risk calculation tool integrating multi-factorial clinical research. Synthesizes demographic, biometric, and sleep hygiene variables into personalized 10-year cardiovascular risk projections.',
      button: {
        text: 'Visit Application',
        url: 'https://heart-attack-prediction-one.vercel.app',
        icon: 'fas fa-external-link-alt'
      },
      button2: {
        text: 'GitHub Repository',
        url: 'https://github.com/monilshah1409/Heart_attack_prediction'
      }
    },
    {
      title: 'VigrahaRakṣitā – Geospatial Disaster Intelligence & Risk AI',
      category: 'Predictive & Statistical Analytics',
      tools: ['Machine Learning', 'Geospatial Data', 'Real-time Alerts', 'Python'],
      dataset: 'Geospatial Sensor & Meteorological Telemetry',
      description:
        'An intelligent disaster prediction and emergency preparedness system leveraging real-time geospatial telemetry and predictive modeling. Provides early warnings, hazard assessment, and data-backed decision support.',
      button: {
        text: 'Visit Application',
        url: 'https://vigrahrakhita.vercel.app',
        icon: 'fas fa-external-link-alt'
      }
    },
    {
      title: 'Lifecycle Carbon Emissions Comparative Modeling Calculator',
      category: 'Predictive & Statistical Analytics',
      tools: ['Data Modeling', 'Mathematical Modeling', 'Comparative Analytics'],
      dataset: 'Supply Chain & Material Emissions Coefficient Database',
      description:
        'Built a quantitative simulation model to compare the cradle-to-gate carbon footprint of industrial materials by factoring in transportation logistics, production intensities, and substitution percentages.',
      button: {
        text: 'Visit Application',
        url: 'https://carbonfootprintcalculaor.vercel.app',
        icon: 'fas fa-external-link-alt'
      }
    },
    {
      title: 'Commercial Property Network Analytics & KPI Tool (7/12 Suvidha)',
      category: 'Commercial Data Solutions',
      tools: ['Dashboard Architecture', 'Data Modeling', 'Stakeholder Analysis'],
      dataset: '200+ Commercial Property Portfolio Records',
      description:
        'Served as technical and data consultant across a 200+ commercial property portfolio. Gathered stakeholder operational requirements and engineered centralized reporting tools that replaced manual data collection.',
    },
    {
      title: 'Workforce Attendance & Wage Distribution Analytics (V K Engineers)',
      category: 'Commercial Data Solutions',
      tools: ['Relational Data Tracking', 'Automated Reporting', 'Payroll Analytics'],
      dataset: 'Industrial Factory Workforce Operational Logs',
      description:
        'Developed an end-to-end workforce management and reporting system for industrial manufacturing staff. Automated attendance tracking and summary report generation for executive management oversight.',
    },
    {
      title: 'Digital Performance & Google Analytics Integration (BioRise Chem)',
      category: 'Commercial Data Solutions',
      tools: ['Google Analytics 4', 'Traffic Analytics', 'Conversion Funnels'],
      dataset: 'Web Traffic, Engagement & Conversion Data',
      description:
        'Built and launched a web platform for chemical distribution with comprehensive Google Analytics instrumentation for behavioral tracking, user journey analysis, and conversion monitoring.',
      button3: {
        text: 'Visit Website',
        url: 'https://biorisechem.com/'
      }
    }
  ];

  const toggleProject = (index) => {
    const newExpanded = new Set(expandedProjects);
    if (newExpanded.has(index)) {
      newExpanded.delete(index);
    } else {
      newExpanded.add(index);
    }
    setExpandedProjects(newExpanded);
  };

  const categories = [
    'All',
    'Power BI Dashboards',
    'Tableau & Visual Analytics',
    'Predictive & Statistical Analytics',
    'Commercial Data Solutions'
  ];

  const filteredProjects = selectedFilter === 'All' 
    ? projects 
    : projects.filter(p => p.category === selectedFilter);

  // Group filtered projects
  const categoryOrder = [
    'Power BI Dashboards',
    'Tableau & Visual Analytics',
    'Predictive & Statistical Analytics',
    'Commercial Data Solutions'
  ];

  const groupedProjects = filteredProjects.reduce((acc, project) => {
    if (!acc[project.category]) {
      acc[project.category] = [];
    }
    acc[project.category].push(project);
    return acc;
  }, {});

  const renderDesktopProjects = () => {
    return (
      <div className="projects-desktop-view">
        {categoryOrder.map((category) => (
          groupedProjects[category] && groupedProjects[category].length > 0 && (
            <div key={category} className="category-section">
              <div className="category-title-row">
                <h2 className="category-title">
                  <i className={
                    category === 'Power BI Dashboards' ? 'fas fa-chart-pie' :
                    category === 'Tableau & Visual Analytics' ? 'fas fa-chart-bar' :
                    category === 'Predictive & Statistical Analytics' ? 'fas fa-brain' : 'fas fa-briefcase'
                  }></i>
                  {category}
                </h2>
                <span className="category-count">{groupedProjects[category].length} Projects</span>
              </div>

              {groupedProjects[category].map((project) => {
                const globalIndex = projects.findIndex(p => p.title === project.title);
                const isExpanded = expandedProjects.has(globalIndex);

                return (
                  <div key={globalIndex} className={`project-card ${isExpanded ? 'is-expanded' : ''}`}>
                    <div className="project-header" onClick={() => toggleProject(globalIndex)}>
                      <div className="project-header-info">
                        <h3>
                          <i className="fas fa-chart-line"></i>
                          {project.title}
                        </h3>
                        {/* Data Tags Row */}
                        <div className="project-meta-badges">
                          {project.dataset && (
                            <span className="meta-badge dataset-badge">
                              <i className="fas fa-database"></i> {project.dataset}
                            </span>
                          )}
                          {project.tools && (
                            <span className="meta-badge tools-badge">
                              <i className="fas fa-tools"></i> {project.tools.slice(0, 3).join(', ')}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="header-actions">
                        {project.button3 && (
                          <button
                            className="quick-redirect-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(project.button3.url, '_blank', 'noopener,noreferrer');
                            }}
                            title="Visit Dashboard"
                          >
                            <span>Dashboard</span>
                            <i className="fas fa-external-link-alt"></i>
                          </button>
                        )}
                        {project.button && (
                          <button
                            className="quick-redirect-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(project.button.url, '_blank', 'noopener,noreferrer');
                            }}
                            title={project.button.text}
                          >
                            <span>{project.button.text.includes('Walkthrough') ? 'Watch Demo' : 'Live Tool'}</span>
                            <i className={project.button.icon || 'fas fa-external-link-alt'}></i>
                          </button>
                        )}
                        <button className="expand-button" aria-label="Toggle details">
                          <i className={`fas ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                      </div>
                    </div>

                    <div className={`project-description ${isExpanded ? 'active' : ''}`}>
                      <p>{project.description}</p>

                      {project.tools && (
                        <div className="project-tools-list">
                          <strong>Analytical Stack:</strong>
                          {project.tools.map((tool, idx) => (
                            <span key={idx} className="tool-tag">{tool}</span>
                          ))}
                        </div>
                      )}

                      {project.iframeUrl && (
                        <div className="powerbi-embed-container">
                          <iframe
                            title={project.title}
                            src={project.iframeUrl}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen={true}
                          ></iframe>
                        </div>
                      )}

                      <div className="project-buttons">
                        {project.button && (
                          <button
                            onClick={() => window.open(project.button.url, '_blank', 'noopener,noreferrer')}
                            className="project-link-button primary"
                          >
                            <i className={project.button.icon || "fas fa-external-link-alt"}></i> {project.button.text}
                          </button>
                        )}
                        {project.button2 && (
                          <button
                            onClick={() => window.open(project.button2.url, '_blank', 'noopener,noreferrer')}
                            className="project-link-button secondary"
                          >
                            <i className="fab fa-github"></i> {project.button2.text}
                          </button>
                        )}
                        {project.button3 && (
                          <button
                            onClick={() => window.open(project.button3.url, '_blank', 'noopener,noreferrer')}
                            className="project-link-button primary"
                          >
                            <i className="fas fa-chart-bar"></i> {project.button3.text}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )
        ))}
      </div>
    );
  };

  const renderMobileProjects = () => {
    return (
      <div className="projects-mobile-view">
        <div className="project-cards-container">
          {filteredProjects.map((project, index) => (
            <div key={index} className="project-card mobile-card">
              <h3>
                <i className="fas fa-chart-line"></i>
                {project.title}
              </h3>
              <p className="project-category-tag">
                <i className="fas fa-tag"></i> {project.category}
              </p>

              {project.dataset && (
                <div className="mobile-meta-badge">
                  <i className="fas fa-database"></i> {project.dataset}
                </div>
              )}

              <div className="project-description-mobile">
                <p>{project.description}</p>

                {project.iframeUrl && (
                  <div className="powerbi-embed-container">
                    <iframe
                      title={project.title}
                      src={project.iframeUrl}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen={true}
                    ></iframe>
                  </div>
                )}
              </div>

              <div className="project-buttons">
                {project.button && (
                  <button
                    onClick={() => window.open(project.button.url, '_blank', 'noopener,noreferrer')}
                    className="project-link-button primary"
                  >
                    <i className={project.button.icon || "fas fa-external-link-alt"}></i> {project.button.text}
                  </button>
                )}
                {project.button2 && (
                  <button
                    onClick={() => window.open(project.button2.url, '_blank', 'noopener,noreferrer')}
                    className="project-link-button secondary"
                  >
                    <i className="fab fa-github"></i> {project.button2.text}
                  </button>
                )}
                {project.button3 && (
                  <button
                    onClick={() => window.open(project.button3.url, '_blank', 'noopener,noreferrer')}
                    className="project-link-button primary"
                  >
                    <i className="fas fa-chart-bar"></i> {project.button3.text}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="projects-container">
      <div className="projects-content-box">
        <div className="projects-header-section">
          <span className="section-badge"><i className="fas fa-chart-pie"></i> Analytics Portfolio</span>
          <h1>Data & Analytics Projects</h1>
          <p className="projects-subtitle">
            Explore interactive business intelligence dashboards, statistical studies, and predictive modeling projects demonstrating end-to-end data pipelines from ingestion to executive insight.
          </p>
        </div>

        {/* Filter Pills */}
        <div className="project-filters">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-pill ${selectedFilter === cat ? 'active' : ''}`}
              onClick={() => setSelectedFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {renderDesktopProjects()}
        {renderMobileProjects()}
      </div>
    </div>
  );
};

export default Projects;
